"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _layouts_1 = require("@layouts");
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _utils_1 = require("@utils");
var ExperiencesPage = function ExperiencesPage(_ref) {
    var _allContentfulEventsA, _allContentfulEventsA2, _allContentfulEventsA3, _allContentfulEventsA4;
    var _ref$data = _ref.data, contentfulEventsAndJourneysLandingPage = _ref$data.contentfulEventsAndJourneysLandingPage, allContentfulEventsAndJourneysCategory = _ref$data.allContentfulEventsAndJourneysCategory;
    if (!contentfulEventsAndJourneysLandingPage)
        return null;
    var title = contentfulEventsAndJourneysLandingPage.title, seoTitle = contentfulEventsAndJourneysLandingPage.seoTitle, sortedExperiences = contentfulEventsAndJourneysLandingPage.sortedExperiences;
    var _React$useState = react_1.default.useState(8), postsToShow = _React$useState[0], setPostsToShow = _React$useState[1];
    var _React$useState2 = react_1.default.useState([]), visibleArticles = _React$useState2[0], setVisibleArticles = _React$useState2[1];
    var _useHash = _utils_1.useHash(), currentCategory = _useHash[0], setCurrentCategory = _useHash[1];
    react_1.default.useEffect(function () {
        var articles = (sortedExperiences === null || sortedExperiences === void 0 ? void 0 : sortedExperiences.filter(function (article) {
            var _article$title;
            return !_utils_1.checkPlaceholderContent(article === null || article === void 0 ? void 0 : (_article$title = article.title) === null || _article$title === void 0 ? void 0 : _article$title.title);
        })) || [];
        if (currentCategory.substr(1) !== "") {
            setVisibleArticles(articles.filter(function (article) {
                var _article$eventsAndJou;
                return article === null || article === void 0 ? void 0 : (_article$eventsAndJou = article.eventsAndJourneysCategories) === null || _article$eventsAndJou === void 0 ? void 0 : _article$eventsAndJou.some(function (cat) {
                    return (cat === null || cat === void 0 ? void 0 : cat.slug) === currentCategory.substr(1);
                });
            }));
        }
        else {
            setVisibleArticles(articles);
        }
        setPostsToShow(8);
    }, [currentCategory]); // Todo: maybe clean up code by putting this up in useEffect
    var currentTitle = currentCategory === "" ? title : (_allContentfulEventsA = allContentfulEventsAndJourneysCategory.edges.find(function (c) {
        return c.node.slug === currentCategory.substr(1);
    })) === null || _allContentfulEventsA === void 0 ? void 0 : _allContentfulEventsA.node.brandedName;
    var currentSubhead = currentCategory === "" ? undefined : (_allContentfulEventsA2 = allContentfulEventsAndJourneysCategory.edges.find(function (c) {
        return c.node.slug === currentCategory.substr(1);
    })) === null || _allContentfulEventsA2 === void 0 ? void 0 : (_allContentfulEventsA3 = _allContentfulEventsA2.node.caption) === null || _allContentfulEventsA3 === void 0 ? void 0 : (_allContentfulEventsA4 = _allContentfulEventsA3.childMarkdownRemark) === null || _allContentfulEventsA4 === void 0 ? void 0 : _allContentfulEventsA4.html;
    var loadMore = function loadMore() {
        return setPostsToShow(postsToShow + 8);
    };
    var categoryLinks = [{
            label: 'all',
            onClick: function onClick() {
                return setCurrentCategory('');
            },
            active: currentCategory === ""
        }];
    allContentfulEventsAndJourneysCategory.edges.filter(function (_ref2) {
        var node = _ref2.node;
        return typeof node.name === 'string';
    }).map(function (_ref3) {
        var node = _ref3.node;
        if (node === null || node.slug === 'announcement')
            return null;
        categoryLinks.push({
            label: node.name,
            onClick: function onClick() {
                return setCurrentCategory(node.slug);
            },
            active: node.slug === currentCategory.substr(1)
        });
    });
    var quickLinksBar = /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: categoryLinks
    });
    var calcTeaserLayout = function calcTeaserLayout(index) {
        var pattern = ['center', 'overlap', 'overlap', 'overlap', 'corner', 'overlap', 'overlap', 'overlap'];
        return pattern[index % pattern.length];
    };
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, {
        subHeaderContent: quickLinksBar
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.SeoTags, {
        title: seoTitle,
        urlPath: "/experiences"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.PageHeader, {
        title: currentTitle,
        subhead: currentSubhead
    }), /*#__PURE__*/ react_1.default.createElement(TeaserList, null, visibleArticles.filter(function (_, index) {
        return index < postsToShow;
    }).map(function (article, index) {
        var _article$title2, _article$eventsAndJou2, _article$eventsAndJou3, _article$homepageExce, _article$homepageExce2, _article$indexImage, _article$indexImage$f, _article$mobileHeroIm, _article$mobileHeroIm2, _article$heroImage, _article$heroImage$fi, _article$mobileHeroIm3, _article$mobileHeroIm4;
        return /*#__PURE__*/ react_1.default.createElement(molecules_1.ArticleTeaser, {
            key: article.slug,
            title: (_article$title2 = article.title) === null || _article$title2 === void 0 ? void 0 : _article$title2.title,
            eyebrowLabel: !!article.eventDate ? article.duration + " | " + article.eventDate : article === null || article === void 0 ? void 0 : (_article$eventsAndJou2 = article.eventsAndJourneysCategories) === null || _article$eventsAndJou2 === void 0 ? void 0 : (_article$eventsAndJou3 = _article$eventsAndJou2[0]) === null || _article$eventsAndJou3 === void 0 ? void 0 : _article$eventsAndJou3.name,
            description: (_article$homepageExce = article.homepageExcerpt) === null || _article$homepageExce === void 0 ? void 0 : (_article$homepageExce2 = _article$homepageExce.childMarkdownRemark) === null || _article$homepageExce2 === void 0 ? void 0 : _article$homepageExce2.html,
            url: article.slug ? "/experiences/" + article.slug : "/experiences/404",
            floatingImageUrl: ((_article$indexImage = article.indexImage) === null || _article$indexImage === void 0 ? void 0 : (_article$indexImage$f = _article$indexImage.file) === null || _article$indexImage$f === void 0 ? void 0 : _article$indexImage$f.url) || ((_article$mobileHeroIm = article.mobileHeroImage) === null || _article$mobileHeroIm === void 0 ? void 0 : (_article$mobileHeroIm2 = _article$mobileHeroIm.file) === null || _article$mobileHeroIm2 === void 0 ? void 0 : _article$mobileHeroIm2.url),
            heroImageUrl: (_article$heroImage = article.heroImage) === null || _article$heroImage === void 0 ? void 0 : (_article$heroImage$fi = _article$heroImage.file) === null || _article$heroImage$fi === void 0 ? void 0 : _article$heroImage$fi.url,
            mobileHeroImageUrl: (_article$mobileHeroIm3 = article.mobileHeroImage) === null || _article$mobileHeroIm3 === void 0 ? void 0 : (_article$mobileHeroIm4 = _article$mobileHeroIm3.file) === null || _article$mobileHeroIm4 === void 0 ? void 0 : _article$mobileHeroIm4.url,
            layout: calcTeaserLayout(index),
            orientation: index % 2 ? 'right' : 'left'
        });
    }), visibleArticles.length < 1 && /*#__PURE__*/ react_1.default.createElement("h1", null, "No results."), postsToShow < visibleArticles.length && /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        onClick: function onClick() {
            return loadMore();
        },
        type: "outline",
        size: "large",
        center: true,
        lines: true
    }, "Load More")), /*#__PURE__*/ react_1.default.createElement(molecules_1.RegisterInLayout, null), /*#__PURE__*/ react_1.default.createElement(organisms_1.HomepageHero, null));
}; // Styling
// note: if this shares anything with TeaserList on landing page, turn into molecule
var TeaserList = styled_components_1.default.div.withConfig({
    displayName: "experiences__TeaserList",
    componentId: "sc-1la5t24-0"
})([""]); // Data
exports.query = "3534191509";
exports.default = ExperiencesPage;
